import { render, staticRenderFns } from "./UVIndexDaily.vue?vue&type=template&id=d41b7d72"
import script from "./UVIndexDaily.vue?vue&type=script&lang=js"
export * from "./UVIndexDaily.vue?vue&type=script&lang=js"
import style0 from "./UVIndexDaily.vue?vue&type=style&index=0&id=d41b7d72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports